import { evolutionPathPair } from "../../evolutions/evolutionPath";
import axios from "../api";
/** `meta-rating-3-chem` also returns the players' 3-chem meta ratings. */
export const getSavedEvolutionPlayers = async (sort) => {
    const res = await axios.get(`/saved-evolution-players${sort ? `?sort-${sort}` : ""}`);
    return res.data;
};
export const saveEvolutionPlayer = async ({ resourceId, evolutionPath, pathwayPath, evoPathId, labPlayStyles, labPlayStylesPlus, }) => {
    await axios.post(`/saved-evolution-players/${resourceId}`, {
        ...evolutionPathPair(evolutionPath, pathwayPath),
        ...(evoPathId && { evoPathId }),
        ...(labPlayStyles && { labPlayStyles }),
        ...(labPlayStylesPlus && { labPlayStylesPlus }),
    });
};
export const deleteSavedEvolutionPlayer = async ({ id, complete, }) => {
    const url = complete
        ? `/saved-evolution-players/${id}/?mark-as-completed`
        : `/saved-evolution-players/${id}`;
    await axios.delete(url);
};
/** `null` clears the state. */
export const updateSavedEvolutionPlayerState = async ({ id, state, }) => {
    await axios.patch(`/saved-evolution-players/${id}`, { state });
};
//# sourceMappingURL=savedEvolutionPlayers.js.map